import { readonly, ref } from "vue";
import { createHttpClient } from "../api/client";

const configValues = ref({});
const loaded = ref(false);
let loadingPromise = null;

function parseEnabled(value, fallback) {
  if (value === undefined || value === null || value === "") return fallback;
  return ["true", "1", "yes", "on"].includes(String(value).trim().toLowerCase());
}

async function load(force = false) {
  if (loaded.value && !force) return configValues.value;
  if (loadingPromise && !force) return loadingPromise;

  const client = createHttpClient();
  loadingPromise = client
    .get("/quark/bead/config/public")
    .then((data) => {
      configValues.value = data && typeof data === "object" ? data : {};
      loaded.value = true;
      return configValues.value;
    })
    .catch(() => {
      // 配置接口异常时保持默认开放，避免运营配置故障扩大为全站不可用。
      loaded.value = true;
      return configValues.value;
    })
    .finally(() => {
      loadingPromise = null;
    });
  return loadingPromise;
}

function isEnabled(key, fallback = true) {
  return parseEnabled(configValues.value[key], fallback);
}

export function useOperationConfig() {
  return {
    values: readonly(configValues),
    loaded: readonly(loaded),
    load,
    isEnabled
  };
}
